import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type RadStaffReminderInput = {
  staffIds: number[]
  id: number
}

export function radSendReminderToStaff(input: RadStaffReminderInput) {
  const { staffIds, id } = input
  return restApiClient
    .url(constructApiUrl(API.rads.sendRadStaffReminder.url, { id }))
    .post({ staffIds })
}
